import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import AutocompleteField from "shared/components/Form/AutocompleteField";
import TextField from "shared/components/Form/TextField";
import UploadImageField from "shared/components/Form/UploadImageField";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { currencyCodeOptions } from "shared/constants/currencies";
import { COLOR_BLACK } from "shared/theme/colors";
import { CheckBoxIcon } from "shared/theme/icons/CheckBoxIcon";
import { CheckedBoxIcon } from "shared/theme/icons/CheckedBoxIcon";
import { useStudioDetails } from "../../context";

const StudioContent: FC = () => {
  const {
    studioDetails,
    logoFile,
    setLogoFile,
    isLoadingLogoFile,
    studioName,
    studioDescription,
    studioCurrencies,
    setStudioCurrencies,
  } = useStudioDetails();

  return (
    <ContentSection title="Studio general">
      {
        <FlexColumn rowGap={"1rem"}>
          <TextField
            label="ID"
            fullWidth
            required
            defaultValue={studioDetails?.id}
            labelColor={COLOR_BLACK}
            disabled
          />
          <TextField
            label="Name*"
            fullWidth
            placeholder="Name"
            required
            {...studioName.input}
            onChange={(e) => {
              studioName?.setValue(e.target.value);
              studioName.setErrors([]);
            }}
            labelColor={COLOR_BLACK}
          />
          <AutocompleteField
            multiple
            disableCloseOnSelect
            id="currency"
            value={studioCurrencies}
            options={currencyCodeOptions}
            onChange={(e, newValue) => {
              setStudioCurrencies(newValue);
            }}
            getOptionLabel={(option) => option}
            isOptionEqualToValue={(option, value) => option === value}
            renderOption={(props, option, { selected }) => {
              return (
                <li {...props} key={props.key}>
                  <Checkbox
                    icon={<CheckBoxIcon />}
                    checkedIcon={<CheckedBoxIcon />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    id={props.id}
                  />
                  <Typography color={COLOR_BLACK} variant="bodyMRegular">
                    {option}
                  </Typography>
                </li>
              );
            }}
            renderInput={(params) => (
              <>
                <FieldLabel
                  label="Supported currencies*"
                  labelColor={COLOR_BLACK}
                />
                <TextField {...params} placeholder="Add a currencies..." />
              </>
            )}
          />
          <TextField
            id="studioDescription"
            label="Description"
            fullWidth
            placeholder="Description (optional)"
            required
            value={studioDescription?.input.value}
            onChange={(e) => studioDescription?.setValue(e.target.value)}
            labelColor={COLOR_BLACK}
          />
          <UploadImageField
            imageFile={logoFile}
            setImageFile={setLogoFile}
            label={"Logo"}
            isLoading={isLoadingLogoFile}
          />
        </FlexColumn>
      }
    </ContentSection>
  );
};

export default StudioContent;
